/**
 * IMPORTS
 */
import {ApplicationError} from 'src/aggregates/err/applicationerror';


/**
 * CODE
 */

/**
 * I am an invalid error code error.
 */
class InvalidErrorCode extends ApplicationError
{
}


/**
 * EXPORTS
 */
export {
    InvalidErrorCode,
};
